import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { FeaturesService } from '../../services/features/features.service';

@Directive({
    selector: '[appHasFeature]',
    standalone: false,
})
export class HasFeatureDirective implements OnInit {
    private viewContainer = inject(ViewContainerRef);
    private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
    private featuresService = inject(FeaturesService);

    @Input('appHasFeature') public hasFeature: string;

    public ngOnInit() {
        const features = this.hasFeature.split(',').map((p) => p.trim());

        if (this.featuresService != null && this.featuresService.hasFeatures(features)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }
}
